import { GrowthDashboardTopBarActions, GrowthDashboardView } from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useDashboard } from '../hooks/useDashboard';

export function DashboardPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useDashboard();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <GrowthDashboardView {...viewProps({ data, loading: isFetching })} />
    </AsyncBoundary>
  );
}
